// src/modules/app-views/ticket-events/pages/Document/decorators/request.js
// Transforms form data before sending to the server

const decorateRequest = ctx => {
  const { data } = ctx;
  if (!data) return data;

  const transformed = { ...data };

  // Remove computed/read-only fields
  delete transformed.soldTickets;
  delete transformed.currentPrice;
  delete transformed.priceHistory;
  delete transformed.lastPriceCalculatedAt;

  // pricingConfig weights: store as decimals (0.4 = 40%)
  // Form stores as percentages (40), convert back to decimals
  if (transformed.pricingConfig) {
    const pc = { ...transformed.pricingConfig };
    if (pc.demandWeight > 1) pc.demandWeight = pc.demandWeight / 100;
    if (pc.scarcityWeight > 1) pc.scarcityWeight = pc.scarcityWeight / 100;
    if (pc.velocityWeight > 1) pc.velocityWeight = pc.velocityWeight / 100;
    transformed.pricingConfig = pc;
  }

  return transformed;
};

export default decorateRequest;
